(function() {
  'use strict';

  angular
    .module('blocks.pdf', []);
})();
